export const PARTNER_EYEBROW="PARTNER_EYEBROW";
export const PARTNER_LABEL="PARTNER_LABEL";
export const PARTNER_DESCRIPTION="PARTNER_DESCRIPTION";
